import { validateName } from '../../../../utils/validations';
import { generateRaceField } from '../common';

const buildBasicInformation = ({
  isAffordable = false,
  propertyStateCode,
  affordablePrograms = [],
}) => {
  const hasRD = affordablePrograms.includes('RD');

  const fields = [
    {
      variant: 'text',
      name: 'legalFirstName',
      label: 'Legal First Name',
      rules: {
        required: true,
        maxLength: 35,
        validate: (value) => {
          if (!validateName(value)) {
            return 'Invalid name';
          }
          return true;
        },
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'text',
      name: 'middleName',
      label: 'Middle Name',
      rules: {
        maxLength: 35,
        validate: (value) => {
          if (value && !validateName(value)) {
            return 'Invalid name';
          }
          return true;
        },
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'text',
      name: 'lastName',
      label: 'Last Name',
      rules: {
        required: true,
        maxLength: 35,
        validate: (value) => {
          if (!validateName(value)) {
            return 'Invalid name';
          }
          return true;
        },
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'singleSelect',
      name: 'suffix',
      label: 'Suffix',
      placeholder: 'Select',
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'text',
      name: 'preferredName',
      label: 'Preferred Name',
      rules: {
        maxLength: 35,
        validate: (value) => {
          if (value && !validateName(value)) {
            return 'Invalid name';
          }
          return true;
        },
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'date',
      name: 'dateOfBirth',
      label: 'Date of Birth',
      placeholder: 'MM/DD/YYYY',
      rules: {
        required: true,
        validate: (value) => {
          if (value > new Date()) {
            return 'Date From cannot be a future date';
          }
          if (value < new Date('1901-01-01')) {
            return 'Invalid date';
          }
          return true;
        },
      },
      GridProps: { xs: 12, sm: 3 },
    },
    ...(isAffordable
      ? [
          {
            variant: 'singleSelect',
            name: 'gender',
            label: 'Gender',
            placeholder: 'Select',
            options: [
              { value: 'male', text: 'Male' },
              { value: 'female', text: 'Female' },
              {
                value: 'doNotWishToProvide',
                text: 'Do not wish to provide',
              },
            ],
            rules: {
              required: true,
            },
            GridProps: { xs: 12, sm: 3 },
          },
        ]
      : []),
    {
      variant: 'space',
      GridProps: { xs: 12, sm: isAffordable ? 3 : 6 },
    },
    ...(isAffordable
      ? [
          {
            variant: 'singleSelect',
            name: 'ethnicity',
            label: 'Ethnicity',
            placeholder: 'Select',
            options: [
              { value: 'hispanic', text: 'Hispanic/Latino' },
              { value: 'notHispanic', text: 'Not Hispanic/Latino' },
              {
                value: 'doNotWishToProvide',
                text: 'Do not wish to provide',
              },
            ],
            rules: {
              required: true,
            },
            GridProps: { xs: 12, sm: 3 },
          },
          generateRaceField({ propertyStateCode }),
          ...(hasRD
            ? [
                {
                  variant: 'radioGroup',
                  name: 'raceSource',
                  label: 'Race Source',
                  options: [
                    {
                      value: 'C-Customer Provided',
                      label: 'Customer Provided',
                    },
                    {
                      value: 'E-Employee Observed',
                      label: 'Employee Observed',
                    },
                  ],
                  rules: {
                    required: true,
                  },
                  sx: {
                    flexDirection: 'row',
                  },
                  GridProps: { xs: 12, sm: 6 },
                },
              ]
            : []),
        ]
      : []),
  ];

  return {
    name: 'basicInformation',
    title: 'BASIC INFORMATION',
    titleVariant: 'subsection',
    container: 'default',
    fields,
  };
};

export default buildBasicInformation;
